export default __webpack_public_path__ + "static/media/element_52.18e22bfa.jpg";